import { space } from './space';
import type { GridGap } from './types';

export const gridGap: GridGap = {
  normal: {
    xs: '0.625rem',
    sm: '0.625rem',
    md: space.s100,
    lg: space.s100,
    xl: space.s100,
  },
  condensed: {
    xs: '0.625rem',
    sm: '0.625rem',
    md: space.s100,
    lg: space.s100,
    xl: space.s100,
  },
  none: {
    xs: '0rem',
    sm: '0rem',
    md: '0rem',
    lg: '0rem',
    xl: '0rem',
  },
};
